import React, { useEffect, useState } from 'react';
import axios from 'axios';
import $ from 'jquery';
//import 'datatables.net-dt/css/jquery.dataTables.min.css';
import 'datatables.net-dt/js/dataTables.dataTables';
import './CustomDataTableStyles.css'; // Import custom CSS
import { MDBInputGroup, MDBInput, MDBIcon, MDBBtn, MDBRow, MDBCol } from 'mdb-react-ui-kit';
import 'mdb-react-ui-kit/dist/css/mdb.min.css';
import { Link, useNavigate, Navigate, Routes } from 'react-router-dom'
import Header from './Header';

const ModalViewSoldAndUnsoldPlots = () => {

    const server_app_api_php = window.SERVER_APP_API_PHP;
    
    const [plotsRidgehill, setPlotsRidgehill] = useState([]);
    const [plotsRidgehillSold, setPlotsRidgehillSold] = useState([]);
    const [plotsHardstone, setPlotsHardstone] = useState([]);
    const [plotsHardstoneSold, setPlotsHardstoneSold] = useState([]);
    const [entriesPerPage, setEntriesPerPage] = useState(10);
    const [entriesPerPageRidgehillSoldPlots, setEntriesPerPageRidgehillSoldPlots] = useState(10);
    const [entriesPerPageHardstone, setEntriesPerPageHardstone] = useState(10);
    const [entriesPerPageHardstoneSoldPlots, setEntriesPerPageHardstoneSoldPlots] = useState(10);
    const [searchQuery, setSearchQuery] = useState('');
    
    const [loading, setLoading] = useState(false);    

     const textContainerStyleSmall = {
        position: 'relative',
        zIndex: 1,
        color: '#fff',
        backgroundColor: 'rgba(0, 0, 0, 0.7)',
        padding: '20px',
    };
 
    useEffect(() => {
        const fetchDataRidgehill = async () => {
            setLoading(true);
            const formData = new FormData();
            formData.append('apiType', 'fetchUnsoldRidgehillPlots');
            try {
                const response = await axios.post(`${server_app_api_php}/server/index.php`, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                });
                setPlotsRidgehill(response.data);
                setLoading(false);
                
                setTimeout(() => {
                    initializeDataTable('#ridgehillPlots');
                }, 1000); // Reduced timeout for quicker feedback
            } catch (error) {
                //alert('There was an error fetching the data. Check Your Internet Connectivity');
                setLoading(false);
            }
        };
        fetchDataRidgehill();
    }, []);

    
    useEffect(() => {
        const fetchDataRidgehillSoldPlots = async () => {
            const formData = new FormData();
            formData.append('apiType', 'fetchSoldRidgehillPlots');
            try {
                const response = await axios.post(`${server_app_api_php}/server/index.php`, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                });
                setPlotsRidgehillSold(response.data);
                
                setTimeout(() => {
                    initializeDataTable('#ridgehillSoldPlots');
                }, 1000); // Reduced timeout for quicker feedback
            } catch (error) {
                //alert('There was an error fetching the data. Check Your Internet Connectivity');
            }
        };
        fetchDataRidgehillSoldPlots();
    }, []);

    useEffect(() => {
        const fetchDataHardstone = async () => {
            const formData = new FormData();
            formData.append('apiType', 'fetchUnsoldHardstonePlots');
            try {
                const response = await axios.post(`${server_app_api_php}/server/index.php`, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                });
                setPlotsHardstone(response.data);
                
                setTimeout(() => {
                    initializeDataTable('#hardstonePlots');
                }, 1000); // Reduced timeout for quicker feedback
            } catch (error) {
                //alert('There was an error fetching the data. Check Your Internet Connectivity');
            }
        };
        fetchDataHardstone();
    }, []);

    
    useEffect(() => {
        const fetchDataHardstoneSoldPlots = async () => {
            const formData = new FormData();
            formData.append('apiType', 'fetchSoldHardstonePlots');
            try {
                const response = await axios.post(`${server_app_api_php}/server/index.php`, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                });
                setPlotsHardstoneSold(response.data);
                
                setTimeout(() => {
                    initializeDataTable('#hardstoneSoldPlots');
                }, 1000); // Reduced timeout for quicker feedback
            } catch (error) {
                //alert('There was an error fetching the data. Check Your Internet Connectivity');
            }
        };
        fetchDataHardstoneSoldPlots();
    }, []);

    const initializeDataTable = (selector) => {
        // Check if DataTable is already initialized
        if ($.fn.DataTable.isDataTable(selector)) {
            $(selector).DataTable().destroy(); // Destroy existing DataTable instance
        }

        $(selector).DataTable({
            pagingType: "full_numbers",
            paging: true,
            searching: true,  // Disable default search
            info: true,
            lengthChange: false
        });
    };

    // Handle custom search
    const handleSearch = (event) => {
        const query = event.target.value;
        setSearchQuery(query);

        // Apply search to both tables
        const ridgehillTable = $('#ridgehillPlots').DataTable();
        const ridgehillTableSoldPlots = $('#ridgehillSoldPlots').DataTable();
        const hardstoneTable = $('#hardstonePlots').DataTable();
        const hardstoneTableSoldPlots = $('#hardstoneSoldPlots').DataTable();

        ridgehillTable.search(query).draw();
        ridgehillTableSoldPlots.search(query).draw();
        hardstoneTable.search(query).draw();
        hardstoneTableSoldPlots.search(query).draw();
    };

    // Handle entries per page
    const handleEntriesPerPage = (event) => {
        const value = parseInt(event.target.value, 10);
        if(value === 1){
        // Update page length for both tables
        $('#ridgehillPlots').DataTable().page.len(-1).draw();
    }
    else{        
        setEntriesPerPage(value);
        // Update page length for both tables
        $('#ridgehillPlots').DataTable().page.len(value).draw();
    }
    };

      // Handle entries per page for Sold Plots Of Ridgehill Estates
      const handleEntriesPerPageRidgehillSoldPlots = (event) => {
        const value = parseInt(event.target.value, 10);
        if(value === 1){
        // Update page length for both tables
        $('#ridgehillSoldPlots').DataTable().page.len(-1).draw();
    }
    else{        
        setEntriesPerPageRidgehillSoldPlots(value);
        // Update page length for both tables
        $('#ridgehillSoldPlots').DataTable().page.len(value).draw();
    }
    };

        // Handle entries per page
        const handleEntriesPerPageHardstone = (event) => {
            const value = parseInt(event.target.value, 10);            
            // Update page length for both tables            
            if(value === 1){
                // Update page length for both tables
                $('#hardstonePlots').DataTable().page.len(-1).draw();
            }
            else{        
                setEntriesPerPageHardstone(value);   
                // Update page length for both tables
                $('#hardstonePlots').DataTable().page.len(value).draw();
            }
        };

         // Handle entries per page Hardstone Estates Sold Plots
         const handleEntriesPerPageHardstoneSoldPlots = (event) => {
            const value = parseInt(event.target.value, 10);            
            // Update page length for both tables            
            if(value === 1){
                // Update page length for both tables
                $('#hardstoneSoldPlots').DataTable().page.len(-1).draw();
            }
            else{        
                setEntriesPerPageHardstoneSoldPlots(value);   
                // Update page length for both tables
                $('#hardstoneSoldPlots').DataTable().page.len(value).draw();
            }
        };

    return (
        <main>
            {/* Navigation Bar */}
            <Header />
                       {/* Main Content */}
            <div className="container mt-5">
                <hr class="mt-5"/>

                
                <div class="py-5 mt-5 form-header ocean blue-gradient">SOLD AND UNSOLD PLOTS</div>
                <ul className="nav nav-tabs" id="myTab" role="tablist">
                    <li className="nav-item">
                        <a className="nav-link active" id="ridgehill-unsold-plots-tab" data-toggle="tab" href="#ridgehill-unsold-plots-content" role="tab" aria-controls="ridgehill-unsold-plots-content" aria-selected="true">Ridgehill Estate Unsold Plots</a>
                    </li>
                    <li className="nav-item">
                        <a className="nav-link" id="ridgehill-sold-plots-tab" data-toggle="tab" href="#ridgehill-sold-plots-content" role="tab" aria-controls="ridgehill-sold-plots-content" aria-selected="false">Ridgehill Estate Sold Plots</a>
                    </li>
                    <li className="nav-item">
                        <a className="nav-link" id="hardstone-unsold-plots-tab" data-toggle="tab" href="#hardstone-unsold-plots-content" role="tab" aria-controls="hardstone-unsold-plots-content" aria-selected="false">Hardstone Estate Unsold Plots</a>
                    </li>

                    <li className="nav-item">
                        <a className="nav-link" id="hardstone-sold-plots-tab" data-toggle="tab" href="#hardstone-sold-plots-content" role="tab" aria-controls="hardstone-sold-plots-content" aria-selected="false">Hardstone Estate Sold Plots</a>
                    </li>
                </ul>
                <div className="tab-content" id="myTabContent">
                   
                <div className="tab-pane fade show active" id="ridgehill-unsold-plots-content" role="tabpanel" aria-labelledby="ridgehill-unsold-plots-tab">
                        <div className="container mt-5">
                            <h2 class="text-uppercase">Ridgehill Estate Unsold Plots</h2>
                            <div className="d-flex justify-content-between mb-0">
                                <div>
                                    <label>Entries per page:</label>
                                    <select className="custom-select d-inline-block ml-2" onChange={handleEntriesPerPage}>
                                        <option value={10}>10</option>
                                        <option value={25}>25</option>
                                        <option value={50}>50</option>
                                        <option value={100}>100</option>
                                        <option value={1}>All Entries</option>
                                    </select>
                                </div>
                                <div>
                                    <input type="hidden" className="form-control" placeholder="Search..." value={searchQuery} onChange={handleSearch} />
                                </div>
                            </div>
                            <table id="ridgehillPlots" className="display table table-striped table-bordered table-hover table-sm w-100">
                                <thead>
                                    <tr>
                                        <th>SN</th>
                                        <th>Old Plot Number</th>
                                        <th>New Plot Number</th>
                                        <th>Old Size</th>
                                        <th>New Size</th>
                                        <th>Old Price</th>
                                        <th>New Price</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {plotsRidgehill.map((plot, index) => (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>{plot.plotNumber}</td>
                                            <td>{plot.plotNumberNew}</td>
                                            <td>{plot.plotArea}</td>
                                            <td>{plot.plotAreasNew}</td>
                                            <td>{plot.plotPrice}</td>
                                            <td>{plot.plotPricesNew}</td>
                                        </tr>
                                    ))}

{ loading ? (
                            <>
                        <div class="spinner-grow text-success"  role="status">
                        </div>
                        </>
                        ) : (<></>)
}
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div className="tab-pane fade" id="ridgehill-sold-plots-content" role="tabpanel" aria-labelledby="ridgehill-sold-plots-tab">
                        <div className="container mt-5">
                            <h2 class="text-uppercase">Ridgehill Estate Sold Plots</h2>
                            <div className="d-flex justify-content-between mb-0">
                                <div>
                                    <label>Entries per page:</label>
                                    <select className="custom-select d-inline-block ml-2" onChange={handleEntriesPerPageRidgehillSoldPlots}>
                                        <option value={10}>10</option>
                                        <option value={25}>25</option>
                                        <option value={50}>50</option>
                                        <option value={100}>100</option>
                                        <option value={1}>All Entries</option>
                                    </select>
                                </div>
                                <div>
                                    <input type="hidden" className="form-control" placeholder="Search..." value={searchQuery} onChange={handleSearch} />
                                </div>
                            </div>
                            <table id="ridgehillSoldPlots" className="display table table-striped table-bordered table-hover table-sm w-100">
                                <thead>
                                    <tr>
                                        <th>SN</th>
                                        <th>Old Plot Number</th>
                                        <th>New Plot Number</th>
                                        <th>Old Size</th>
                                        <th>New Size</th>
                                        <th>Old Price</th>
                                        <th>New Price</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {plotsRidgehillSold.map((plot, index) => (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>{plot.plotNumber}</td>
                                            <td>{plot.plotNumberNew}</td>
                                            <td>{plot.plotArea}</td>
                                            <td>{plot.plotAreasNew}</td>
                                            <td>{plot.plotPrice}</td>
                                            <td>{plot.plotPricesNew}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div className="tab-pane fade" id="hardstone-unsold-plots-content" role="tabpanel" aria-labelledby="hardstone-unsold-plots-tab">
                        <div className="container mt-5">
                            <h2 class="text-uppercase">Hardstone Estate Unsold Plots</h2>
                            <div className="d-flex justify-content-between mb-0">
                                <div>
                                    <label>Entries per page:</label>
                                    <select className="custom-select d-inline-block ml-2" onChange={handleEntriesPerPageHardstone}>
                                       <option value={10}>10</option>
                                        <option value={25}>25</option>
                                        <option value={50}>50</option>
                                        <option value={100}>100</option>
                                        <option value={1}>All Entries</option>
                                    </select>
                                </div>
                                <div>
                                    <input type="hidden" className="form-control" placeholder="Search..." value={searchQuery} onChange={handleSearch} />
                                </div>
                            </div>
                            <table id="hardstonePlots" className="display table table-striped table-bordered table-hover table-sm w-100">
                                <thead>
                                    <tr>
                                        <th>SN</th>
                                        <th>Old Plot Number</th>
                                        <th>New Plot Number</th>
                                        <th>Old Size</th>
                                        <th>New Size</th>
                                        <th>Old Price</th>
                                        <th>New Price</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {plotsHardstone.map((plot, index) => (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>{plot.plotNumber}</td>
                                            <td>{plot.plotNumberNew}</td>
                                            <td>{plot.plotArea}</td>
                                            <td>{plot.plotAreasNew}</td>
                                            <td>{plot.plotPrice}</td>
                                            <td>{plot.plotPricesNew}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div className="tab-pane fade" id="hardstone-sold-plots-content" role="tabpanel" aria-labelledby="hardstone-sold-plots-tab">
                        <div className="container mt-5">
                            <h2 class="text-uppercase">Hardstone Estate Sold Plots</h2>
                            <div className="d-flex justify-content-between mb-0">
                                <div>
                                    <label>Entries per page:</label>
                                    <select className="custom-select d-inline-block ml-2" onChange={handleEntriesPerPageHardstoneSoldPlots}>
                                       <option value={10}>10</option>
                                        <option value={25}>25</option>
                                        <option value={50}>50</option>
                                        <option value={100}>100</option>
                                        <option value={1}>All Entries</option>
                                    </select>
                                </div>
                                <div>
                                    <input type="hidden" className="form-control" placeholder="Search..." value={searchQuery} onChange={handleSearch} />
                                </div>
                            </div>
                            <table id="hardstoneSoldPlots" className="display table table-striped table-bordered table-hover table-sm w-100">
                                <thead>
                                    <tr>
                                        <th>SN</th>
                                        <th>Old Plot Number</th>
                                        <th>New Plot Number</th>
                                        <th>Old Size</th>
                                        <th>New Size</th>
                                        <th>Old Price</th>
                                        <th>New Price</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {plotsHardstoneSold.map((plot, index) => (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>{plot.plotNumber}</td>
                                            <td>{plot.plotNumberNew}</td>
                                            <td>{plot.plotArea}</td>
                                            <td>{plot.plotAreasNew}</td>
                                            <td>{plot.plotPrice}</td>
                                            <td>{plot.plotPricesNew}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>

                </div>
            </div>

       </main>
    );
};

export default ModalViewSoldAndUnsoldPlots;
